
import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatMenuTrigger } from '@angular/material';
import { MatDialog, MatDialogConfig } from "@angular/material";

import { SharedService } from 'src/app/Sharedservice/SharedService';
import { SchedularServiceService } from 'src/app/Services/Schedular/schedular-service.service';
import { IUserDetails } from 'src/app/models/IUsersDetails';
import { CalendarTemplate, CalendarTemplateDay } from 'src/app/models/CalendarTemplate';

import { CalDatesService } from '../cal-dates.service';
import { AssignTemplateDialogModel } from "../models";
import { AssignTemplateDialogComponent } from '../assign-template-dialog/assign-template-dialog.component';

@Component({
  selector: 'app-assign-template',
  templateUrl: './assign-template.component.html',
  styleUrls: ['./assign-template.component.css'],
  providers: [CalDatesService]
})
export class AssignTemplateComponent implements OnInit {
  @ViewChild(MatMenuTrigger, { static: true }) trigger: MatMenuTrigger;

//  @ViewChild(AssignTemplatePopupComponent, { static: true }) menu: AssignTemplatePopupComponent;
  @ViewChild('calendar',  { static: true }) calendarComponent: any//FullCalendarComponent;

  public providersList: IUserDetails[];
  public chosenProvider: IUserDetails;
  public templateList: CalendarTemplate[];

  calEventSources =  [ ];

  calPlugins = [];//[ dayGridPlugin, interactionPlugin ];
  calDefaultView = 'dayGridMonth';
  calHeader = {
    left: 'prev,title,next',
    right: ''
  };


  openMenu(dateClickInfo) {
//    this.menu.open(dateClickInfo.jsEvent);
  }

  itemSelected(item:number) {
  }
  constructor(private sharedService: SharedService, private schedulerService: SchedularServiceService, public dialog: MatDialog,
    private datePipe: DatePipe, private dateService: CalDatesService) {
    this.getAllProviders();
  }

  ngOnInit() {
    // this. displayProviderEntries();
  }

  calSelectAllow = (info) => {
    let d = new Date();
    if (info.start < this.dateService.dateOnly(d)) // do not allow selection before today
      return false;
    else {
      d = new Date(info.start); // do not allow more than one day to be selected at the one time
      d.setDate(info.start.getDate() + 1);
      if (d.getFullYear() !== info.end.getFullYear() || d.getMonth() !== info.end.getMonth() || d.getDay() !== info.end.getDay())
        return false;
    }
    return true;
  }

  calDateSelected(dateClickInfo) {
    if (!this.chosenProvider) {
      alert("Please choose a provider from the list");
      return false;
    }

 //   this.trigger.openMenu();
   //dateClickInfo.jsEvent;
 //  this.openMenu(dateClickInfo);

    var j = dateClickInfo.start.getDay();
    var chosenDay: string;
    if (j == 0)
      chosenDay = 'Sunday';
    else if (j == 1)
      chosenDay = 'Monday';
    else if (j == 2)
      chosenDay = 'Tuesday';
    else if (j == 3)
      chosenDay = 'Wednesday';
    else if (j == 4)
      chosenDay = 'Thursday';
    else if (j == 5)
      chosenDay = 'Friday';
    else if (j == 6 )
      chosenDay = 'Saturday';

    var filteredList: CalendarTemplate[] = [];
    if (this.templateList) {
      for (let i = 0; i < this.templateList.length; i++) {
        if (this.templateList[i].calendarTemplatesDays) {
          if (this.templateList[i].calendarTemplatesDays.find(day => day.dayofweek == chosenDay)) {
            filteredList.push(this.templateList[i]);
          }
        }
      }
    }

    if (!this.templateList || this.templateList.length == 0) {
      alert("No templates available for the chosen provider");
    }
    else if (filteredList.length == 0) {
      alert("No templates available that include the chosen day");
    }
    else {
      //alert(filteredList.length.toString())
      this.openDialog(filteredList, dateClickInfo);
    }

  }


  getAllProviders() {
    this.sharedService.getAllUsersByRole("Doctor").subscribe(data => {
      //fixme is this right? need to only get active ones here?
      this.providersList = data.filter(rec => rec.isActive == true);
    });
  }


  providerSelectionChanged(event) {
    if (event.source.selected == true) {
      this.chosenProvider = this.providersList.find(provider => provider.providerId = event.source.value);
      if (this.chosenProvider) {
        this.refreshCalendar(this.chosenProvider.providerId);
  //      this.refreshTemplates(this.chosenProvider.providerId, this.chosenLocation.locationId);
      }
      else {
//        this.mode = 0;
      }
    }
  }

  refreshCalendar(provId) {
     
    this.templateList = [];
    this.calEventSources = [];
    this.schedulerService.getCalendarTemplates(provId).subscribe(data => {
      this.templateList = data.filter(rec => rec.isActive == true && rec.calendarTemplatesDays);
      //temp fixme
      //this.templateList = data;
      if (this.templateList && this.templateList.length > 0) {
        this.displayProviderEntries();
    //    this.initBlankSlots();
  //      this.mode = screenMode.addNew;
      }
      else {
          alert("There are no active templates available for this provider.");
//        this.mode = 0;
      }
    },
    error => {
      //this.alertService.error("There was a problem loading availabilities: "+error);
    });

  }

  showHardcodedEntries() {
    //get current month that is displayed
    var calStartDate = this.calendarComponent.getApi().view.currentStart;
    var calEndDate = this.calendarComponent.getApi().view.currentEnd;

    var dt1 = new Date(calStartDate);
    dt1.setDate(dt1.getDate() + 4);
    var dt2 = new Date(dt1);
    dt2.setDate(dt2.getDate() + 1);
    var dt3 = new Date(calStartDate);
    dt3.setDate(dt3.getDate() + 11);
    var dt4 = new Date(dt3);
    dt4.setDate(dt4.getDate() + 1);
    var dt5 = new Date(calStartDate);
    dt5.setDate(dt5.getDate() + 18);
    var dt6 = new Date(dt5);
    dt6.setDate(dt6.getDate() + 1);
    var dt7 = new Date(calStartDate);
    dt7.setDate(dt7.getDate() + 25);
    var dt8 = new Date(dt7);
    dt8.setDate(dt8.getDate() + 1);
    var dt9 = new Date(calStartDate);
    dt9.setDate(dt9.getDate() + 17);
    var dt10 = new Date(dt9);
    dt10.setDate(dt10.getDate() + 1);


    let eventArray = [];
    this.calEventSources = [
      {
        events: [ // put the array in the `events` property
          {
            start : dt1,
            end : dt2,
            allDay: true,
            rendering: 'background'
          },
          {
            start  : dt3,
            end : dt4,
            allDay: true,
            rendering: 'background'
          },
          {
            start  : dt5,
            end : dt6,
            allDay: true,
            rendering: 'background'
          },
          {
            start  : dt7,
            end : dt8,
            allDay: true,
            rendering: 'background'
          }

/*
          ,
          {
            title  : 'Benny Benjamin',
            start  : this.dateNow.setHours(this.dateNow.getHours() + 3),
            end : this.dateNow.setMinutes(this.dateNow.getMinutes() + 20 )
          }
*/
  /*        ,
          {
            title  : 'event3',
            start  : '2020-01-09T12:30:00',
          } */
        ],
        color: '#85c705'
        //, // border & background

        //color: 'black',     //an option!
        //textColor: 'rgba(0,0,0,.87) !important'
      }
      ,
      {
        events: [ // put the array in the `events` property
          {
            start  : dt9, //this.dateNow,
            end : dt10,
            allDay: true,
            rendering: 'background'
          }
          /*
          ,
          {
            title  : 'Donald De Marco',
            start  : this.dateB,
            end : this.dateF
          }
          */
        ],
        color: '#fbaaa7', // border & background

        //color: 'black',     //an option!
        textColor: 'rgba(0,0,0,.87) !important'
      }


    ];
  }

  displayProviderEntries() {
    //this.showHardcodedEntries();
 
    let colourList = ['#cefecc', '#eeccff', '#fff4a8', '#a0ceff', '#ff9595', '#d6b484', '#ff9966', '#f9ccca', '#40e0d0'];
    //get current month that is displayed
    let calStartDate = this.calendarComponent.getApi().view.currentStart;
    let calEndDate = this.calendarComponent.getApi().view.currentEnd;

    let filteredList: CalendarTemplateDay[] = [];

    /*
    this.calEventSources = [
      {
        events: [ // put the array in the `events` property
        ],
        color: '#85c705'
      },
      {
        events: [ // put the array in the `events` property
        ],
        color: '#fbaaa7', // border & background
      }
    ];
    */
    this.calEventSources = [
    ];



    if (this.templateList) {
      let today = this.dateService.todayDateOnly();
      let lastColourIndex = 0;
      let lastTemplateIndex = 0;
      let addedTemplate = false;
      for (let i = 0; i < this.templateList.length; i++) {
        addedTemplate = false
        if (this.templateList[i].calendarTemplatesDays) {
//          filteredList = this.templateList[i].calendarTemplatesDays.filter(
  //            entry => (new Date(entry.startTime)) <= calEndDate && (new Date(entry.endTime)) >= calStartDate);
          filteredList = this.templateList[i].calendarTemplatesDays.filter(entry => (new Date(entry.endTime)) >= today);
          if (filteredList) {
            for (let j = 0; j < filteredList.length; j++) {
              let templateStart: Date = this.dateService.dateOnly(new Date(filteredList[j].startTime));
              let templateEnd: Date = this.dateService.dateOnly(new Date(filteredList[j].endTime));
              //let x = this.getAllDates(filteredList[j].dayofweek, calStartDate, templateStart, templateEnd);
              let x = this.dateService.getAllTemplateDates(filteredList[j].dayofweek, calStartDate, templateStart);//, templateEnd);
              if (x.length) {
                addedTemplate = true;
                this.calEventSources.push({events: [], color: colourList[lastColourIndex]});
                for (let k = 0; k < x.length; k++) {
                  this.calEventSources[lastTemplateIndex].events.push({
                    start : x[k],
                    end : this.dateService.nextDay(x[k]),
                    allDay: true,
                    rendering: 'background'
                  });
                }
              }
            }
          }
          if (addedTemplate == true) {
            lastTemplateIndex = lastTemplateIndex + 1;
            if (lastColourIndex == (colourList.length - 1))
              lastColourIndex = 0;
            else
              lastColourIndex = lastColourIndex + 1;
          }
        }
      }
    }
  }

/*
  getAllDates(weekday: string, monthStart: Date, templateStart: Date, templateEnd: Date) {
    let dlist: Date[] = [];

    if (templateEnd < monthStart)
      return dlist;

    let weekdayNum: number = this.dateService.weekdayStringToNum(weekday);
    let d = new Date(monthStart);
    let firstDate: Date;

    //find first instance of the weekday
    for (let i = 1; i <= 7; i++) {
      if (d.getDay() === weekdayNum) {
        firstDate = new Date(d);
        break;
      }
      d.setDate(monthStart.getDate() + i);
    }

    //get list of all instances of this weekday up until the end of the template
    if (templateStart <= firstDate && templateEnd >= firstDate)
      dlist.push(firstDate);
    let j: number = 7;
    d = new Date(firstDate);
    while (true) {
      d.setDate(d.getDate() + 7);
      if (d > templateEnd)
        break;
      if (templateStart <= d)
        dlist.push(new Date(d));
      j = j + 7;
    }

    return dlist;
*/



    //get list of all instances of this weekday in the month
    /*
    dlist.push(firstDate);
    for (let i = 1; i <= 4; i++) {
      d.setDate(firstDate.getDate() + (i * 7));
      if (d.getMonth() === monthStart.getMonth())
        dlist.push(new Date(d));
    }

    var elist = dlist.filter(entry => entry >= templateStart && entry <= templateEnd);
    return elist;
    */
/*
  }
*/

  openDialog(filteredList: CalendarTemplate[], dateClickInfo /* evTarget , element: templateRow, index, slot: templateSlot */) {
    var dialogInput: AssignTemplateDialogModel;

    dialogInput = { templateList: filteredList, startDate: dateClickInfo.start, endDate: new Date("05/31/2020") };

/*
    dialogInput.visitCategoryList = this.visitCategoryList;
    dialogInput.chosenId = slot.slotType;
    if (index == 1)
       dialogInput.startTime = element.hourDisplay;
     else
        dialogInput.startTime = element.hourDisplay.replace("00",
            ((index - 1) * 15).toString());
     dialogInput.duration = 15;
     dialogInput.numBookings = 1;

    const dialogRef = this.dialog.open(SlotDialogComponent, {
        //width: '250px',
        data:  dialogInput});
*/

    const dialogRef = this.dialog.open(AssignTemplateDialogComponent, {
      //width: '250px',
      data:  dialogInput,panelClass: 'CustomDailog'});

    dialogRef.afterClosed().subscribe(
      data => {
        if (data) {
          let entry = filteredList.find(calTemplate => calTemplate.calendarTemplateId == data.chosenId);
          entry.modifiedOn = new Date();
          //entry.createdBy = '';
          entry.modifiedBy = '';
          //entry.calendarTemplateDescription = '';
          //entry.isActive = true;
          for (let day of entry.calendarTemplatesDays) {
            day.startTime = this.dateService.dateAsString(day.startTime, data.startDate);
            day.endTime = this.dateService.dateAsString(day.endTime, data.endDate);
         }
 
          this.schedulerService.updateCalendarTemplate(entry).subscribe(data => {
            this.refreshCalendar(this.chosenProvider.providerId);
//            var s;
  //          s = "";


    //        this.schedulerService.getCalendarTemplate(entry.calendarTemplateId).subscribe(data2 => {
      //        var xx;
        //      xx = '';
          //  },
            //error => {
              //this.alertService.error("There was a problem loading availabilities: "+error);
       //     });



          },
          error => {
            //this.alertService.error("There was a problem loading availabilities: "+error);
          });


/*
          let entry = this.visitCategoryList.find(visitCat => visitCat.visitType.attributeId == data.chosenId);
          const chosenIdNum: number = parseInt(data.chosenId, 10);
          if (chosenIdNum != dialogInput.chosenId) {
            slot.slotType = chosenIdNum;
            if (entry) {
              slot.slotText = entry.visitType.attributeName;
              slot.slotClass = entry.colorClass;
            }
            else {
              slot.slotText = '';
              slot.slotClass = '';
            }
            evTarget.classList.remove("highlight");
          }
          else {
          }
          slot.duration = data.duration;
          slot.numBookings = data.numBookings;
*/
        }
        else {
        }
      }
    );
  }

}
